import React from "react";
import styled from "styled-components";

import {
  AdminSection,
  AdminSectionBadge,
  AdminSectionHeader,
} from "../section_engine";


function normalizedValue(value) {
  if (
    typeof value === "string"
    && value.trim()
  ) {
    return value.trim();
  }

  return null;
}


function displayValue(value) {
  return normalizedValue(value)
    ?? "Non renseigné";
}


function resolveEmployeeName(employee) {
  const parts = [
    normalizedValue(
      employee?.first_name,
    ),
    normalizedValue(
      employee?.last_name,
    ),
  ].filter(Boolean);

  if (parts.length > 0) {
    return parts.join(" ");
  }

  return "Salarié";
}


export default function EmployeeIdentitySummary({
  detail,
}) {
  const employee =
    detail?.employee ?? {};

  const user =
    detail?.user ?? null;

  const organization =
    detail?.organization ?? {};

  const establishment =
    organization?.establishment ?? null;

  const department =
    organization?.department ?? null;

  const position =
    organization?.position ?? null;

  const manager =
    organization?.manager ?? null;

  return (
    <AdminSection
      aria-labelledby={
        "employee-identity-summary-title"
      }
    >
      <AdminSectionHeader>
        <AdminSectionBadge>
          Employee
        </AdminSectionBadge>

        <h1
          id="employee-identity-summary-title"
          tabIndex="-1"
        >
          {resolveEmployeeName(
            employee,
          )}
        </h1>

        <p>
          Fiche individuelle du salarié
          dans le scope société courant.
        </p>
      </AdminSectionHeader>

      <IdentityGrid>
        <IdentityItem>
          <dt>Matricule</dt>
          <dd>
            {displayValue(
              employee?.employee_number,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Statut</dt>
          <dd>
            {displayValue(
              employee?.status,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Société</dt>
          <dd>
            {displayValue(
              employee?.company?.name,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Établissement</dt>
          <dd>
            {displayValue(
              establishment?.name,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Département</dt>
          <dd>
            {displayValue(
              department?.name,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Poste</dt>
          <dd>
            {displayValue(
              position?.name,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Manager</dt>
          <dd>
            {displayValue(
              manager?.name,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Compte utilisateur</dt>
          <dd>
            {displayValue(
              user?.email,
            )}
          </dd>
        </IdentityItem>
      </IdentityGrid>
    </AdminSection>
  );
}


const IdentityGrid = styled.dl`
  display: grid;

  grid-template-columns:
    repeat(
      auto-fit,
      minmax(190px, 1fr)
    );

  gap: 0.8rem;

  margin: 0;
`;


const IdentityItem = styled.div`
  min-width: 0;

  padding: 0.75rem;

  border:
    1px solid
    rgba(255, 255, 255, 0.08);

  border-radius: 14px;

  background:
    rgba(11, 19, 40, 0.24);

  dt {
    margin-bottom: 0.35rem;

    color:
      rgba(247, 247, 247, 0.62);

    font-size: 0.76rem;
    font-weight: 700;

    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  dd {
    margin: 0;

    color: #fff9ea;

    font-size: 0.94rem;
    font-weight: 700;

    overflow-wrap: anywhere;
  }
`;
